var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_11330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5322 19.0332C8.72656 19.0332 5.61523 15.9219 5.61523 12.1162C5.61523 8.31055 8.73535 5.19922 12.5322 5.19922C16.3379 5.19922 19.4492 8.31055 19.4492 12.1162C19.4492 13.5928 18.9834 14.9551 18.1924 16.0801L22.0156 19.9209C22.2617 20.167 22.376 20.4922 22.376 20.8262C22.376 21.5469 21.8398 22.1182 21.1104 22.1182C20.7588 22.1182 20.4336 21.9951 20.1787 21.749L16.3291 17.8906C15.2393 18.6113 13.9297 19.0332 12.5322 19.0332ZM12.5322 17.1875C15.3184 17.1875 17.6035 14.9023 17.6035 12.1162C17.6035 9.33008 15.3184 7.04492 12.5322 7.04492C9.74609 7.04492 7.46094 9.33008 7.46094 12.1162C7.46094 14.9023 9.74609 17.1875 12.5322 17.1875Z",
    fill: "#53555D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_11330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.16da08b5f62b8f5e29e3ecc4c02b6e1c.svg";
export { ForwardRef as ReactComponent };